import React, { useContext, useEffect, useState } from "react";
import useFetchList from "../../commons/hooks/useFetchList";
import { EDIT_GROUP_MENU, LIST_PRODUCT_GROUPED } from "../../commons/constants/api-urls";
import { AppContext } from "../../contexts/AppContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useTable from "../../commons/hooks/useTable";
import useGroupMenu from "./useGroupMenu";
import { Form, message } from "antd";
import GroupMenuLayout from "./GroupMenuLayout";
import { ColumnsType } from "antd/es/table";
import styles from "./styles.module.scss";
import defaultAxios from "../../commons/utils/axios";
import { routerNavigation } from "../../commons/constants/routers";
import CustomModal from "../../commons/components/CustomModal/CustomModal";

const EditGroupMenu = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { storeId } = useParams<{ storeId: string }>();
  const { groupId } = useParams<{ groupId: string }>();
  const { currentStore, findAndSetStore } = useContext(AppContext);
  const { onShowSizeChange, page, perPage, setPage } = useTable();
  const {
    getListProduct,
    dataSrc,
    getBodyEdit,
    dataSelected,
    initDataSelected,
    getGroupMenuDetail,
    menuDetail,
    handleEditMarkProductReview,
    openModal,
    setOpenModal,
    isAdd,
  } = useGroupMenu();
  const [keyword, setKeyword] = useState("");

  const { data, total, refresh, loading, setLoading } = useFetchList<ProductItem>(
    currentStore ? LIST_PRODUCT_GROUPED(currentStore.id, groupId || "") : "",
    {
      perPage,
      page,
      search: keyword.trim(),
      paginationMetadataStyle: "body",
    }
  );

  async function onFinish(values: { "group-name": string }) {
    try {
      setLoading(true);

      const body = getBodyEdit(values);

      await defaultAxios.put(EDIT_GROUP_MENU(currentStore.id, groupId!), body);
      navigate(routerNavigation.STORES.GROUP_MENU(storeId!));

      message.success("Edit group success");
    } catch (error) {
      message.error("Edit group failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const columns: ColumnsType<ProductMenu> = [
    {
      title: "Product Name",
      dataIndex: "name",
      render: (text, record, index) => {
        return text;
      },
    },
    {
      title: "Product ID ",
      dataIndex: "id",
      render: (text, record, index) => {
        return text;
      },
    },
    {
      title: "Action ",
      render: (text, record, index) => {
        return (
          <div className={styles.actions}>
            <div className={styles.edit}>
              <div
                className={`${styles.preview} ${record.isGrouped && styles.true}`}
                onClick={() => handleEditMarkProductReview(record.id, storeId!, groupId!, record.isGrouped, setLoading)}
              >
                {record.isGrouped ? "Remove" : "Add To Group"}
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (data) {
      getListProduct(data);
    }
  }, [dataSelected, data]);

  useEffect(() => {
    form.setFieldValue("group-name", menuDetail?.name);
  }, [menuDetail]);

  useEffect(() => {
    if (data) {
      initDataSelected(data);
    }
  }, [data]);

  useEffect(() => {
    if (!storeId || !groupId) return;
    findAndSetStore(storeId);
    getGroupMenuDetail(storeId, groupId);
  }, [storeId]);
  return (
    <div>
      {menuDetail && (
        <Form form={form} name="form-group" onFinish={onFinish}>
          <GroupMenuLayout
            isEdit
            columns={columns}
            dataSrc={dataSrc}
            loading={loading}
            onShowSizeChange={onShowSizeChange}
            page={page}
            perPage={perPage}
            selectedProductId={menuDetail.productQuantity}
            setKeyword={setKeyword}
            setPage={setPage}
            total={total}
          />
        </Form>
      )}
      <CustomModal
        onOk={() => setOpenModal(false)}
        onCancel={() => setOpenModal(false)}
        open={openModal}
        children={
          <p style={{ color: "white", textAlign: "center", fontSize: "22px" }}>
            {" "}
            {isAdd ? "Add Product Success" : "Remove Product Success"}
          </p>
        }
      ></CustomModal>
    </div>
  );
};

export default EditGroupMenu;
